import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1)
    }
  },
  paper: {
    padding: theme.spacing(2),
    boxShadow: 'none!important',
    border: '1px solid #ddd',
    maxWidth: '500px',
    margin: '0 auto'
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
    display: 'flex'
  },
  formControlFile: { width: '85%' },
  CircularProgressbar: { width: '15%' },
  buttonSubmit: {
    marginBottom: 10
  },
  buttonSearch: {
    top: '11px',
    position: 'absolute',
    width: '70px',
    right: '2px',
    height: '50px',
    padding: '0 10px'
  },
  hiddenInput: {
    display: 'none'
  },
  fileInput: {
    width: '100%',
    margin: '10px 0',
    display: 'flex',
    marginLeft: '0px!important'
  },
  datePicker: { marginLeft: '0px!important' },
  buttonSubmit: {
    marginBottom: 10
  },
  formControl: { marginTop: '10px' },
  wrapSendBox: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%'
  },
  phoneNumberGroup: {
    display: 'flex'
  },
  firstDivision: {
    display: 'flex',
    flex: 1
  },
  addBtn: {
    backgroundColor: 'transparent',
    border: '0px',
    color: 'green',
    margin: 0
  },
  removeBtn: {
    backgroundColor: 'transparent',
    border: '0px',
    color: 'red',
    margin: 0
  },
  secondDivision: {
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex'
  }
}))
